import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../hooks/UserContext';
import { useRole } from '../../hooks/useRole';

// maxLevel: legacy — kept for backward compat but now the dimension checks matter more
// dimension: 'iot' | 'project' | undefined — which access dimension is required
export default function AuthGuard({ children, maxLevel = 99, dimension }) {
  const { user } = useUser();
  const { level, hasProjectAccess, hasIotAccess } = useRole();
  const location = useLocation();

  const hasToken = localStorage.getItem('tkn');

  if (!user && !hasToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // No role assigned — redirect to waiting page
  if (level >= 99) {
    return <Navigate to="/waiting" replace />;
  }

  // Dimension-based access check
  if (dimension === 'iot' && !hasIotAccess) {
    return <Navigate to="/project/home" replace />;
  }
  if (dimension === 'project' && !hasProjectAccess) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Legacy level check (admin section requires level <= 20 OR iot access)
  if (level > maxLevel && !hasIotAccess) {
    return <Navigate to="/project/home" replace />;
  }

  return children;
}
